import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthProvider';
import PetanqueLoader from './PetanqueLoader';
import BoarDenied from './BoarDenied';

// `module` names a Virgy module (a restricted page of Sangly, e.g. 'encodage').
// This only keeps the router tidy — the real gate is the DRF permission on the
// page's endpoints, so a hand-typed URL gets an empty screen, not the data.
const PrivateRoute = ({ children, module, moduleLabel }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <PetanqueLoader size={44} roll />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  // Signed in but not granted Sangly → the boar turns them away. (=== false so a
  // stale cached user without the field doesn't get wrongly blocked before refresh.)
  if (user.has_access === false) return <BoarDenied />;
  // Same `=== false` rule one level down: a page missing from `modules` isn't
  // restricted, so pages nobody has narrowed stay open with no client change.
  if (module && user.modules?.[module] === false) {
    return <BoarDenied page={moduleLabel || module} />;
  }
  return children;
};

export default PrivateRoute;
